import styled from 'styled-components';
import { FormControlLabel, TextField, Typography } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 60%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const RadioLabel = styled(Typography)`
  width: 75px;
  margin: auto 20px;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
`;

export const RadioControlLabel = styled(FormControlLabel)`
  width: 120px;
`;

export const ContentWrapper = styled(Container)`
  margin-bottom: 20px;
  margin-left: 10px;
  flex-direction: column;
  width: ${({ isRadio }: { isRadio?: boolean }) => (isRadio ? '300px' : '200px')};

  .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
    height: 40px;
    width: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Error = styled.div`
  color: ${({ theme }) => theme.colors.red};
  text-align: left;
  margin-left: ${({ ml }: { ml?: boolean }) => (ml ? '20px' : '0')};
`;

export const ContentRadioLabel = styled(Typography)`
  width: 300px;
  margin: -10px 0;
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4375em;
`;

export const ButtonWrapper = styled.div`
  margin-left: 10px;
  margin-bottom: 10px;
`;

export const PasswordTextField = styled(TextField)`
  .css-b52kj1::-ms-reveal,
  .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input::-ms-reveal {
    display: none;
  }
`;
